/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GetAspectsResponse as ApiGetAspectsResponse } from '../models/api/get-aspects-response';
import { GetCobenefitsResponse as ApiGetCobenefitsResponse } from '../models/api/get-cobenefits-response';
import { GetTreeResponse as ApiGetTreeResponse } from '../models/api/get-tree-response';
import { getAspects } from '../fn/http-api/get-aspects';
import { GetAspects$Params } from '../fn/http-api/get-aspects';
import { getCobenefits } from '../fn/http-api/get-cobenefits';
import { GetCobenefits$Params } from '../fn/http-api/get-cobenefits';
import { getTree } from '../fn/http-api/get-tree';
import { GetTree$Params } from '../fn/http-api/get-tree';

@Injectable({ providedIn: 'root' })
export class HttpApiService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCobenefits()` */
  static readonly GetCobenefitsPath = '/v1/transitionelements/cobenefits';

  /**
   * Get cobenefits for transition element(s).
   *
   * Get cobenefits connected to a transition element
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCobenefits()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCobenefits$Response(
    params: GetCobenefits$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiGetCobenefitsResponse>> {
    return getCobenefits(this.http, this.rootUrl, params, context);
  }

  /**
   * Get cobenefits for transition element(s).
   *
   * Get cobenefits connected to a transition element
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCobenefits$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCobenefits(params: GetCobenefits$Params, context?: HttpContext): Observable<ApiGetCobenefitsResponse> {
    return this.getCobenefits$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiGetCobenefitsResponse>): ApiGetCobenefitsResponse => r.body)
    );
  }

  /** Path part for operation `getAspects()` */
  static readonly GetAspectsPath = '/v1/transitionelements/{id}/aspects';

  /**
   * Get aspects for transition element.
   *
   * Get aspects and its attributes connected to a transition element
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAspects()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAspects$Response(
    params: GetAspects$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiGetAspectsResponse>> {
    return getAspects(this.http, this.rootUrl, params, context);
  }

  /**
   * Get aspects for transition element.
   *
   * Get aspects and its attributes connected to a transition element
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAspects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAspects(params: GetAspects$Params, context?: HttpContext): Observable<ApiGetAspectsResponse> {
    return this.getAspects$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiGetAspectsResponse>): ApiGetAspectsResponse => r.body)
    );
  }

  /** Path part for operation `getTree()` */
  static readonly GetTreePath = '/v1/trees/{id}';

  /**
   * Get tree.
   *
   * Get a specific tree
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTree()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTree$Response(params: GetTree$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiGetTreeResponse>> {
    return getTree(this.http, this.rootUrl, params, context);
  }

  /**
   * Get tree.
   *
   * Get a specific tree
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTree$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTree(params: GetTree$Params, context?: HttpContext): Observable<ApiGetTreeResponse> {
    return this.getTree$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiGetTreeResponse>): ApiGetTreeResponse => r.body)
    );
  }
}
